import { createFileRoute, notFound } from "@tanstack/react-router";
import { LegalView } from "@/components/pages/LegalView";
import { terms } from "@/content/legal";
import { meta } from "@/content/meta";
import { isLocale } from "@/i18n/locales";
import { seoHead } from "@/lib/site";

export const Route = createFileRoute("/$locale/terms")({
  head: ({ params }) =>
    isLocale(params.locale)
      ? seoHead({
          locale: params.locale,
          path: "/terms",
          ...meta[params.locale].terms,
        })
      : {},
  component: TermsRoute,
});

function TermsRoute() {
  const { locale } = Route.useParams();
  if (!isLocale(locale)) throw notFound();
  return <LegalView locale={locale} doc={terms[locale]} />;
}
